const firebaseConfig = {
  apiKey: "AIzaSyDllW81RugUx51o8AVlPxlNBEVmiCE7rUw",
  authDomain: "e-bike-client.firebaseapp.com",
  projectId: "e-bike-client",
  storageBucket: "e-bike-client.appspot.com",
  messagingSenderId: "665083035693",
  appId: "1:665083035693:web:3868f6510773b07833f8a4",
};
export default firebaseConfig;
